<ng-template>
  <ui-select [uiPlaceHolder]="baseValue | localize" [style]="{ width: '100%' }" [formControl]="formControl">
    <ui-option *ngFor="let item of options" [uiValue]="item" [uiLabel]="item | localize"></ui-option>
  </ui-select>
</ng-template>
